import * as React from 'react';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';

type Props = {
    noun: string;
};

export function EmptyState(props: Props) {
    return (
        <EmptyStateSmall
            title={`No ${props.noun}s to see yet`}
            subtitle='This is where they’ll be available later'
            icon={
                <div style={{width: 80}}>
                    <Illustration src='cactus-empty-state' width='100%' height='100%' />
                </div>
            }
        />
    );
}
